<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Itens Laudo Checklist">
          <listar-ItensLaudoCheckList />
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListarItensLaudoCheckList from '@/components/patio/ListarItensLaudoCheckList'
export default {
  name: 'ItensLaudoCheckList',
  data() {
    return {
      page: {
        title: 'Gerenciamento de Itens Laudo Checklist',
      },
      breadcrumbs: [
        {
          text: 'Administrativo',
          disabled: true,
          to: '/administrativo',
        },
        {
          text: 'Item Laudo Checklist',
          disabled: true,
        },
      ],
    }
  },
  components: {
    ListarItensLaudoCheckList,
  },
}
</script>

<style></style>
